import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-count-data',
  templateUrl: './stock-count-data.component.html',
  styleUrls: ['./stock-count-data.component.css']
})
export class StockCountDataComponent implements OnInit {
    stockCountDataKeyno;

    public menu?: Menu;

    public itemsListStockCountDatas: Item[] = [];
    
    public stockValueStockButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockget', gotoParms: () => this.menu!.stock_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockCountDataKeyno = this.stateService.getStateParams()['stockcountdata_keyno'];
    }

    private async loadMenu() {
        if (!!this.stockCountDataKeyno) {
            this.menu = (await this.datatask.Post(983, { stockcountdata_keyno: this.stockCountDataKeyno }))[0];
        }
    }

    private async loadStockCountDatas() {
        if (!this.menu) return;

        this.itemsListStockCountDatas = await this.datatask.Post(984, { stockcountdata_keyno: this.menu.stockcountdata_keyno });
    }

    private async init() {
        await this.loadMenu();
        this.loadStockCountDatas();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    stockcountdata_keyno: string;
    stock_keyno: string;
    stockvalue_stock: string;
    stockvalue_counted: string;
    approved: string;
    url_picture: string;
    prodname_long: string;
    price: string;
    businessco_valuta_id: string;
    floatingstock_is_updated: string;
}
